import React from 'react'
import { View } from 'react-native'
import { Formik, FormikHelpers } from 'formik'
import * as yup from 'yup'
import tw from 'tailwind-rn'

import { HGTextInput } from '../../components/Form'
import { HGButton, HGText, HGView } from '../../components/HGUI'

const validationSchema = yup.object({
  password: yup
    .string()
    .min(6, 'Bitte geben Sie ein Passwort mit mindestens 6 Zeichen ein')
    .required('Bitte geben Sie ein sichereres Passwort ein.'),
  passwordConfirm: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Passwörter müssen übereinstimmen.'),
})

export type ChangePasswordValues = {
  password: string
  passwordConfirm: string
}

const initialValues: ChangePasswordValues = {
  password: '',
  passwordConfirm: '',
}

type Props = {
  buttonLabel?: string
  onSubmit: (
    credentials: ChangePasswordValues,
    setSubmitting: (value: boolean) => void
  ) => void
}

const ChangePasswordForm = (props: Props) => {
  const { onSubmit, buttonLabel } = props

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(
        values: ChangePasswordValues,
        { setSubmitting }: FormikHelpers<ChangePasswordValues>
      ) => {
        onSubmit(values, setSubmitting)
      }}
    >
      {({
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        isValid,
        values,
        errors,
      }) => (
        <HGView>
          <View>
            <HGTextInput
              onChangeText={handleChange('password')}
              onBlur={handleBlur('password')}
              value={values.password}
              placeholder="Neues Passwort eingeben …"
              textContentType="newPassword"
              secureTextEntry
            />

            <HGText style={tw('text-gray-600 mt-1 text-sm')}>
              Neues Passwort
            </HGText>

            {errors.password && (
              <HGText style={tw('text-sm mt-1 text-red-500')}>
                {errors.password}
              </HGText>
            )}
          </View>

          <View style={tw('mt-4')}>
            <HGTextInput
              onChangeText={handleChange('passwordConfirm')}
              onBlur={handleBlur('passwordConfirm')}
              value={values.passwordConfirm}
              placeholder="Neues Passwort wiederholen …"
              secureTextEntry
              textContentType="newPassword"
              onSubmitEditing={() => handleSubmit}
            />

            <HGText style={tw('text-gray-600 mt-1 text-sm')}>
              Neues Passwort wiederholen
            </HGText>

            {errors.passwordConfirm && (
              <HGText style={tw('text-sm mt-1 text-red-500')}>
                {errors.passwordConfirm}
              </HGText>
            )}
          </View>

          <View style={tw('items-center')}>
            <HGButton
              disabled={isSubmitting || !isValid}
              title={!isSubmitting ? buttonLabel : 'Bitte warten …'}
              onPress={handleSubmit}
              style={tw('mt-6 mb-6 w-full')}
            />
          </View>
        </HGView>
      )}
    </Formik>
  )
}

ChangePasswordForm.defaultProps = {
  buttonLabel: 'Bestätigen',
}

export default ChangePasswordForm
